import React, {
  useRef,
  useState,
  useCallback,
  useLayoutEffect,
  useImperativeHandle,
} from 'react';

// TODO: Improve this hook to eliminate the use of state
export const useClickableCard = (
  forwardedRef?: React.ForwardedRef<HTMLDivElement>,
) => {
  const primaryActionRef = useRef<any>(null);
  const clickAreaRef = useRef<HTMLDivElement>(null);

  useImperativeHandle(
    forwardedRef,
    () => clickAreaRef.current as HTMLDivElement,
  );

  const [up, setUp] = useState<number>(0);
  const [down, setDown] = useState<number>(0);
  const [isIgnoredClick, setIsIgnoredClick] = useState<any>(null);

  // Inspired by redundant click handling on Heydon Pickering's Inclusive Card Components:
  // https://inclusive-components.design/cards/#theredundantclickevent

  const onCardMouseDown = useCallback(() => setDown(+new Date()), []);
  const onCardMouseUp = useCallback(
    (event: React.SyntheticEvent) => {
      event.preventDefault();

      const target = event.target as HTMLElement;
      const isIgnoredTarget = target.closest('[data-ignore-click]') !== null;
      setIsIgnoredClick(isIgnoredTarget);
      return setUp(+new Date());
    },
    [setIsIgnoredClick],
  );

  useLayoutEffect(() => {
    const clickDuration = up - down;
    const isClickStarted = clickDuration > 0;
    const isShortClick = clickDuration < 500;
    const isWithinClickThreshold = isClickStarted && isShortClick;
    const isPrimaryActionClicked =
      primaryActionRef.current === document.activeElement;

    if (
      primaryActionRef.current &&
      isWithinClickThreshold &&
      !isPrimaryActionClicked &&
      !isIgnoredClick
    ) {
      primaryActionRef.current.click();
    }
  }, [up, down, isIgnoredClick]);

  return {
    primaryActionRef,
    clickAreaRef,
    onCardMouseUp,
    onCardMouseDown,
  };
};
